<template lang="pug">
  div.uploader
    div.uploader__label {{ label }}
      span(v-if="required").input-field__label-tooltip  * <span>Обязательное поле</span>
    template(v-for="file in files")
      div.upload-bar(:key="file.name")
        div.upload-bar__ico
          img(:src="icoDoc")
        div.upload-bar__file
          span.upload-bar__file-name(:title="file.name") {{file.name}}
          span.upload-bar__file-size {{bytesToSize(file.size)}}
        div.upload-bar__progress(v-if="uploadProgress[file.size]")
          div.upload-bar__progress-bar(:style="{width: `${uploadProgress[file.size]}%`}")
        button.upload-bar__cancel(v-if="file.name" type="button" @click="removeUploadedFile(file.name)")
          img(:src="icoCancel")

    div.upload-error(:class="[{'is-error': hasError}]") {{currentError}}

    form(enctype="multipart/form-data" class="file-form")
      div.file-upload
        input-file.file-upload__input(
          ref="inputFile"
          :target="API_URL"
          :alias="'file'"
          action="POST"
          :progress="progress"
          :start="startUpload"
          :finish="finishUpload")
        btn.file-upload__btn(
          type="button"
          :disabled="files.length >= maxFilesNum"
          :baseClass="'btn-sec'"
          :txt="'Загрузить'"
          :event="'openFileDialog'")
      .file-text {{this.$props.description}}
</template>

<script>
  // api
  import { deleteUploadedFile } from '@/api';

  // vendors
  import _find from 'lodash/find';
  import _remove from 'lodash/remove';

  // constants
  import { API_URL } from '@/constants'

  // assets
  import icoDoc from './assets/ico-doc.svg'
  import icoCancel from './assets/ico-cancel.svg'

  // components
  import InputFile from './InputFile'
  import PrimaryButton from '@/components/UI/Button/Button.vue'

  // mixins
  import fieldProps from '@/mixins/fieldProps'

  export default {
    name: 'FileUpload',
    mixins: [fieldProps],
    components: {
      'input-file': InputFile,
      'btn': PrimaryButton
    },
    props: {
      totalSizeLimit: {
        type: Number,
        default: 9000
      },
      uploaded: {
        type: Array,
        default: () => ([])
      },
      mimeType: {
        type: Array,
        default: null
      }
    },
    data () {
      return {
        API_URL: `${API_URL}answer_file`,
        // API_URL: `${API_URL}${this.$props.output_type}`,
        icoDoc: icoDoc,
        icoCancel: icoCancel,
        currentFile: {},
        files: [],
        uploadedFiles: this.$props.uploaded,
        maxFilesNum: 9,
        filesSize: 0,
        uploadProgress: {},
        errors: {
          'numLimit': 'Можно добавить не более 9 файлов',
          'sizeLimit': '',
          'fileType': 'Недопустимый формат файла',
          'uploadError': 'Извините, не удалось загрузить файл',
          'empty': 'Прикрепите файл'
        },
        currentError: null,
        hasError: false
      }
    },
    computed: {
      sizeLimit () {
        return this.$props.totalSizeLimit * 1000
      },
      userId () {
        return this.$store.state.session.userId
      }
    },
    methods: {
      openFileDialog () {
        this.$refs.inputFile.$el.click()
      },
      fileChange (e) {
        // TODO: запилить проверку на существование файла - совпадение по имнеи/весу
        if (this.files.length < this.maxFilesNum && this.filesSize < this.sizeLimit) {
          this.filesSize += e.size
          if (this.files.length === this.maxFilesNum) {
            return this.showError('numLimit')
          } else if (this.filesSize >= this.sizeLimit) {
            this.filesSize = this.filesSize - e.size;
            return this.showError('sizeLimit')
          } else if (this.$props.mimeType && !this.$props.mimeType.includes(e.type)) {
            return this.showError('fileType')
          } else {
            let uploadObj = {
              'question': this.$props.question,
              'user': this.userId
            };
            this.$refs.inputFile.uploadFile(uploadObj);
            this.files.push(e);
            this.currentFile = e;
            this.currentError = null;
            this.validator();
          }
        }
      },
      progress (prcnt) {
        this.uploadProgress[this.currentFile.size] = prcnt;
        this.$forceUpdate();
      },
      startUpload () {
        return 'startUpload';
      },
      finishUpload (result) {
        if (typeof result === 'object' && result.status === 201) {
          // проверим есть ли запись в files - если нет - отмена загрузки файла
          if (!_find(this.files, ['name', this.currentFile.name])) {
            deleteUploadedFile(result.data);
            return false;
          }
          this.uploadedFiles.push({ [result.data]: this.currentFile });
          this.setAnswer();
        } else {
          this.showError('uploadError');
          _remove(this.files, (o) => {
            return o.name === this.currentFile.name;
          })
        }
        this.$refs.inputFile.$el.value = '';
      },
      bytesToSize (bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        if (bytes === 0) return '0 Byte'
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
        return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`
      },
      showError (error) {
        this.currentError = this.errors[error]
      },
      removeUploadedFile (fileName) {
        _remove(this.files, (o) => {
          return o.name === fileName;
        })
        const file = _remove(this.uploadedFiles, (o) => {
          const key = Object.keys(o)[0];
          return o[key].name === fileName;
        });

        if (file) {
          deleteUploadedFile(Number(Object.keys(file[0])[0]));
        }

        this.setAnswer();
        this.currentError = null;
        this.$forceUpdate();
        this.validator();
      },
      validator () {
        if (!this.$props.required) {
          return true
        }

        let isEmpty = !this.files.length;

        if (isEmpty) {
          this.$store.commit('polls/updatePollErrorState', isEmpty)
          this.hasError = isEmpty
          return this.showError('empty')
        }

        this.hasError = isEmpty
      },
      setAnswer () {
        const answer = {
          question: this.$props.question,
          pollId: this.$props.pollId,
          options: this.uploadedFiles
        };
        this.$store.dispatch('answers/addRemoveAnswer', answer);
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.$on('openFileDialog', this.openFileDialog)
        this.$on('progress', this.progress)
        this.$on('startUpload', this.startUpload)
        this.$on('finishUpload', this.finishUpload)
        this.$on('fileChange', this.fileChange)
        this.errors['sizeLimit'] = 'Общий вес файлов не должен превышать ' + this.bytesToSize(this.sizeLimit);
      });
      if (this.$props.uploaded.length) {
        this.$props.uploaded.map((item) => {
          this.files.push(Object.values(item)[0]);
        })
      }
    }
  }
</script>

<style lang="scss" src="./assets/file-upload.scss"></style>
